import api from "@/api";
import i18n from "@/i18n";
import { createLatestRequestGate, parseApiError, parseCollectionAuthorization } from "@/helpers/teamAuthorization";

const { t } = i18n.global;
const categoryRequestGate = createLatestRequestGate();
export default {
  state: {
    saleCategories: [],
    saleCategoriesData: {},
    saleCategoryTeamId: 0,
    collectionAuthorization: null,
    collectionError: null,
  },
  getters: {
    saleCategories: (state) => state.saleCategories,
    saleCategoriesData: (state) => state.saleCategoriesData,
    saleCategoryTeamId: (state) => state.saleCategoryTeamId,
    saleCategoryCollectionAuthorization: (state) => state.collectionAuthorization,
    saleCategoryCollectionError: (state) => state.collectionError,
  },
  mutations: {
    setSaleCategories: (state, data) => {
      state.saleCategories = data;
    },

    setSaleCategoriesData: (state, data) => {
      state.saleCategoriesData = data;
    },

    setSaleCategoryTeamId: (state, data) => {
      state.saleCategoryTeamId = data;
    },
    setSaleCategoryCollectionAuthorization: (state, data) => {
      state.collectionAuthorization = data;
    },
    setSaleCategoryCollectionError: (state, data) => {
      state.collectionError = data;
    },
  },
  actions: {

    deleteSaleCategory: async (_, { id, teamId }) => {
      try {
        await api({ requiresAuth: true }).delete(
            `/v1/sales-categories/${id}`,
            { data: { team_id: teamId } }
        );
      } catch (err) {
        console.error(err);
      }
    },
    getSaleCategories: async ({ commit }) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/sales-categories"
        );
        const { data } = response;
        commit("setSaleCategories", data);
      } catch (err) {
        console.error(err);
      }
    },

    getSaleCategoriesByTeam: async ({ commit }, teamId) => {
      const requestKey = `sales-categories:${teamId}`;
      const { signal } = categoryRequestGate.start(requestKey);
      commit("setSaleCategories", []);
      commit("setSaleCategoryCollectionAuthorization", null);
      commit("setSaleCategoryCollectionError", null);
      try {
        const response = await api({ requiresAuth: true }).get(
          `/v1/teams/${teamId}/sales-categories`,
          { signal }
        );
        if (!categoryRequestGate.isActive(requestKey)) return;
        commit("setSaleCategories", response.data);
        commit("setSaleCategoryCollectionAuthorization", parseCollectionAuthorization(response));
      } catch (err) {
        if (err.code === "ERR_CANCELED" || !categoryRequestGate.isActive(requestKey)) return;
        commit("setSaleCategoryCollectionError", parseApiError(err));
      }
    },

    getSaleCategoriesFormData: async ({ commit }, teamId) => {
      try {
        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          "/v1/partials/sales-categories-forms",
          { params: { team_id: teamId } }
        );
        commit("setSaleCategoriesData", data);
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.somethingWentWrong"),
        });
      }
    },

    addSaleCategory: async ({ commit }, { title, provision, teamId }) => {
      try {
        await api({ requiresAuth: true }).post("/v1/sales-categories", {
          title,
          agent_provision: provision,
          team_id: teamId,
        });
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.saleCategoryCreatedSuccessfully"),
        });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.somethingWentWrong"),
        });
        throw err;
      }
    },
  },
};
